var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 25,
    viewBox: "0 0 10 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_203_580)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.86345 7.26855C8.95646 7.36156 9.00296 7.46852 9.00296 7.58943C9.00296 7.71033 8.95646 7.81729 8.86345 7.9103L3.38075 13.393L8.86345 18.8757C8.95646 18.9687 9.00296 19.0757 9.00296 19.1966C9.00296 19.3175 8.95646 19.4244 8.86345 19.5174L8.16591 20.215C8.0729 20.308 7.96595 20.3545 7.84504 20.3545C7.72413 20.3545 7.61718 20.308 7.52417 20.215L1.02305 13.7139C0.930048 13.6209 0.883545 13.5139 0.883545 13.393C0.883545 13.2721 0.930048 13.1651 1.02305 13.0721L7.52417 6.57101C7.61718 6.478 7.72413 6.4315 7.84504 6.4315C7.96595 6.4315 8.0729 6.478 8.16591 6.57101L8.86345 7.26855Z",
    fill: "#F26522"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.44,
    height: 25,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStr);
export default __webpack_public_path__ + "static/media/str.389e14ffd079f27117af9bb20f0d14f9.svg";
export { ForwardRef as ReactComponent };